import axios from 'axios';
const http = axios.create({
    baseURL: process.env.VUE_APP_HEADER,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json', //        'application/json' // multipart/form-data
    },
});

export default http;